<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">RECARGAS DE CLIENTES</div>
    <div class="box-container">
      <div class="box-filtres">
        <table width="100%">
          <tbody>
            <tr>
              <td width="380px">CLIENTE</td>
              <td width="100px">FECHA</td>
              <!--<td width="200px">FLOTA</td>-->
              <td width="100px">VALOR RECARGA</td>
              <td width="1px"></td>
            </tr>
            <tr>
              <td>
                <Select2
                  v-model="cliente_unique"
                  :options="clientes"
                  @select="onSelectCliente($event)"
                />
              </td>
              <td>
                <input
                  class="form-control center"
                  type="text"
                  datatype="fecha"
                  autocomplete="off"
                  id="fecha_recarga"
                  readonly="true"
                />
                <!--
                            <select class="form-control" v-model="flota">
                                <option selected></option>
                                <option v-for="item in flotas" :value="item.uniqueid" :key="item.uniqueid">
                                    {{ item.descripcion }}
                                </option>
                            </select>
                        -->
              </td>
              <td>
                <input
                  v-model="valor_recarga"
                  class="form-control"
                  style="text-transform: uppercase"
                />
              </td>
              <td></td>
            </tr>
            <tr>
              <td colspan="4" class="text-right">
                <table class="table tablet-borded">
                  <tbody>
                    <tr>
                      <td width="80%">CONSUMO</td>
                      <td class="b">{{ GLOBAL.FORMATO_MONEY(consumo) }}</td>
                    </tr>
                    <tr>
                      <td>SALDO</td>
                      <td class="b">{{ GLOBAL.FORMATO_MONEY(saldo) }}</td>
                    </tr>
                    <tr>
                      <td>RECARGA</td>
                      <td class="b">
                        {{ GLOBAL.FORMATO_MONEY(valor_recarga) }}
                      </td>
                    </tr>
                    <tr>
                      <td>NUEVO SALDO</td>
                      <td class="b">
                        {{
                          GLOBAL.FORMATO_MONEY(
                            saldo + parseFloat(valor_recarga)
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="text-right">
                <hr />
                <div style="height: 30px; color: red">
                  {{ mensaje }}
                </div>

                <button class="btn btn-info" @click="guardarRecarga">
                  <i class="fa-solid fa-save"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table
          id="table1"
          width="100%"
          class="display nowrap"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th width="100px">Fecha</th>
              <th width="100px">Consecutivo</th>
              <th width="100px">Cliente</th>
              <th width="100px">Recarga</th>
              <th width="100px">Estado</th>
              <th width="100px">Acciones</th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import VehiculoService from "../Vehiculos/VehiculoService.js";
import ReporteService from "../../service/ReporteService";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";

export default {
  components: { Select2 },
  data() {
    return {
      GLOBAL,
      person: null,
      vehiculo: null,
      tercero: null,
      flota: null,
      valor_recarga: 0,
      fecha_recarga: null,
      loading: false,
      consumo: null,
      saldo: null,
      disableBotonGuardar: true,
      mensaje: "",
      reporte: [],
      acuerdo: null,
      vehiculoService: null,
      clienteService: null,
      clientes: [],
      cliente: null,
      cliente_unique: null,
      credito: {},
      flotas: [],
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.vehiculoService = new VehiculoService();
    this.clienteService = new ClienteService();

    this.credito = {};
    this.credito.flota = "";

    this.mensaje = "";
  },
  mounted() {
    $("input[datatype='fecha']").datetimepicker({
      onSelect: (dateText) => {
        this.actualizaComponente(dateText);
      },
    });
    this.getListaCliente();
    this.getListaRecargas();
  },
  methods: {
    actualizaComponente(selected) {
      this.fecha_recarga = selected;

      this.clienteService
        .getSaldoCliente(this.person, this.cliente._id, this.fecha_recarga)
        .then((response) => {
          console.log(response);
          try {
            this.consumo = parseFloat(response.consumo);
            this.saldo = parseFloat(response.saldo);
          } catch (error) {
            this.consumo = 0;
            this.saldo = 0;
          }
        });
    },

    onSelectCliente({ id, text }) {
      for (var i in this.clientes) {
        if (this.clientes[i].id == this.cliente_unique) {
          this.cliente = this.clientes[i];
          this.cliente._id = this.clientes[i].id;
          break;
        }
      }

      /*
            this.vehiculoService.getFlotasConVehiculos(this.person, this.cliente).then(data => {
                console.log(data)
                this.flotas = data
            })
            */
    },

    getListaCliente() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          console.log(data);

          this.clientes = [];
          for (var i in data) {
            this.clientes.push({
              id: data[i]._id,
              text: data[i].nombres,
              nit: data[i].identificacion,
              nombres: data[i].nombres,
            });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    guardarRecarga() {
      var validacion = "OK";

      if (this.fecha_recarga == null || this.fecha_recarga == "") {
        validacion = "Verifique la fecha";
      }

      if (validacion == "OK") {
        this.mensaje = "";
        this.disableBotonGuardar = false;
        var request = {};
        request.tercero_id = this.cliente._id;
        request.tercero_nit = this.cliente.nit;
        request.tercero_nombre = this.cliente.nombres;
        request.tercero_nombre = this.cliente.nombres;

        request.fecha_recarga = this.fecha_recarga;
        request.venta_total = parseFloat(this.valor_recarga);

        this.clienteService
          .agregarRecargarCliente(this.person, request)
          .then((response) => {
            this.valor_recarga = "";
            this.consumo = "";
            this.saldo = "";
            this.cliente_unique = "";
            this.cliente = null;
            this.fecha_recarga = "";
            $("#fecha_recarga").val("");
            this.getListaRecargas();
          });
      } else {
        this.mensaje = validacion;
      }
    },

    updateRecarga(data) {
      console.log(data);
      this.clienteService.updateRecarga(this.person, data).then((response) => {
        this.valor_recarga = "";
        this.consumo = "";
        this.saldo = "";
        this.getListaRecargas();
      });
    },

    getListaRecargas() {
      this.reporte = [];
      this.loading = true;
      this.clienteService
        .getRecargarCliente(this.person)
        .then((response) => {
          console.log(response);
          this.reporte = response;
        })
        .then(() => {
          //FIX: en este orden soluciona el problema de datatable repetida//
          try {
            $("#table1").DataTable().destroy();
          } catch (error) {}
          $("#containter-table").html(this.table);

          const boxes = document.querySelectorAll(".btt");
          boxes.forEach((box) => {
            box.remove();
          });

          //END FIX://
          var vm = this;
          $("#table1").DataTable({
            data: this.reporte,
            columns: [
              { data: "fecha" },
              {
                render: function (data, type, row) {
                  return row.prefijo + "-" + row.consecutivo;
                },
              },
              { data: "tercero_nombre" },
              {
                class: "text-right",
                render: function (data, type, row) {
                  return GLOBAL.FORMATO_MONEY(row.venta_total);
                },
              },
              {
                class: "text-center",
                render: function (data, type, row) {
                  return row.estado == "A" ? "ACTIVO" : "ANULADO";
                },
              },
              {
                class: "text-center",
                render: function (data, type, row) {
                  return "";
                },
              },
            ],
            createdRow: function (row, data) {
              var deleteBtn = $(
                "<button class='btn btn-sm btn-warning'><i class='fa-regular fa-trash-can'></i></button> "
              );
              if (data.estado == "A") {
                $(deleteBtn).on("click", function () {
                  vm.updateRecarga(data);
                });
              } else {
                deleteBtn = $(
                  "<button disabled class='btn btn-sm btn-secondary'><i class='fa-regular fa-trash-can'></i></button> "
                );
              }

              $("td", row).eq(5).append(deleteBtn);
            },
            dom:
              "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
              "<'row'<'col-sm-12'tr>>" +
              "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
            buttons: [
              {
                extend: "copyHtml5",
                text: '<i class="fa-regular fa-clipboard"></i>',
              },
              {
                extend: "excelHtml5",
                text: '<i class="fa-regular fa-file-excel"></i>',
              },
              {
                extend: "csvHtml5",
                text: '<i class="fa-solid fa-file-csv"></i>',
              },
              {
                extend: "pdfHtml5",
                text: '<i class="fa-regular fa-file-pdf"></i>',
              },
            ],
            responsive: false,
            scrollX: true,
            lengthMenu: [
              [10, 20, 50, -1],
              [10, 20, 50, "Todos"],
            ],
            language: {
              url: "plugins/Spanish.json",
            },
          });
          this.loading = false;

          var vm = this;
          $("#table1 tbody").off("click");
          $("#table1 tbody").on("click", "#edit", vm, function () {
            let id = $(this).data("id");
            vm.openMe(id);
          });
        });
    },
  },
};
</script>
